module.exports = __webpack_public_path__ + "static/img/Stock Research Company.d302d8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Stock Research Company.png
// module id = BGyp
// module chunks = 1